<!-- review-status.component.html -->
<div class="review-wrapper">
  <div class="back" (click)="goToDashboard()">
    <em class="material-icons">arrow_back_ios</em>
  </div>
  
  <div class="review-card-container">
    <div class="review-card">
      <div class="left-section">
        <img src="/assets/images/review_saf_icon.png" alt="Under Review" />
      </div>
      
      <div class="right-section">
        <h2>Your fundraiser is under review.</h2>
        <p>This usually takes 7-8 days. Until then, add more details from your dashboard to strengthen your fundraiser.</p>
        
        <button class="dashboard-btn" (click)="goToDashboard()">
          Go to Dashboard
          <em class="material-icons">arrow_forward_ios</em>
        </button>
        
       
      </div>
    </div>
    <button class="mobile-btn" (click)="goToDashboard()">
      Go to Dashboard
      <em class="material-icons">arrow_forward_ios</em>
    </button>
  </div>
</div>